import { render, staticRenderFns } from "./LoginBar.vue?vue&type=template&id=063642a2&scoped=true&"
import script from "./LoginBar.vue?vue&type=script&lang=js&"
export * from "./LoginBar.vue?vue&type=script&lang=js&"
import style0 from "./LoginBar.vue?vue&type=style&index=0&id=063642a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063642a2",
  null
  
)

export default component.exports